import { render, staticRenderFns } from "./PolicyTimeline.vue?vue&type=template&id=9cb8c250&"
import script from "./PolicyTimeline.vue?vue&type=script&lang=js&"
export * from "./PolicyTimeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports